export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4605.f1cad584.jpg";